import Swiper from '../../common/custom-swiper/custom-swiper';

export default new class productSlider {
  constructor() {
    this.sliderContainerSelector = 'product-slider__container';
    this.paginationSelector = 'product-slider__pagination';
    this.bulletSelector = 'product-slider__bullet';
    this.activeBulletSelector = 'product-slider__bullet_active';

    this.navSliderContainerSelector = 'product-nav-slider';
    this.navSliderContainerHiddenSelector = 'product-nav-slider_visually-hidden';

    this.mqString = '(min-width: 769px)';
    this.delay = 200;

    this.video = $('.video-youtube');
    this.fluidEl = $('.area-video');
    this.finestraW = 0;

    this.handler();
  }

  handler() {
    const slider = document.querySelector(`.${this.sliderContainerSelector}`);

    if (!slider) return;

    document.addEventListener('DOMContentLoaded', () => {
      this.changeNavVisibility();
      this.init();
    });

    this.videoProporzione();
    this.scalaVideo();

    window.addEventListener('resize', () => {
      this.changeNavVisibility();
      this.scalaVideo();
    });
  }

  init() {
    const el = `.${this.paginationSelector}`;
    this.initNavSlider();

    this.productMainSlider = new Swiper(`.${this.sliderContainerSelector}`, {
      slidesPerView: 1,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      pagination: {
        el,
        type: 'bullets',
        bulletClass: this.bulletSelector,
        bulletActiveClass: this.activeBulletSelector,
      },
      loop: false,
      thumbs: {
        swiper: this.productNavSlider,
      },
      controller: {
        control: this.productNavSlider,
      },
    });
  }

  changeNavVisibility() {
    const vpState = this.checkViewport();

    if (vpState) {
      $(`.${this.navSliderContainerSelector}`).removeClass(this.navSliderContainerHiddenSelector);
    } else {
      $(`.${this.navSliderContainerSelector}`).addClass(this.navSliderContainerHiddenSelector);
    }
  }

  initNavSlider() {
    this.productNavSlider = new Swiper(`.${this.navSliderContainerSelector}`, {
      slidesPerView: 7,
      spaceBetween: 15,
      watchOverflow: true,
      observer: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      controller: {
        control: this.productSlider,
      },
    });
  }

  checkViewport() {
    return window.matchMedia(this.mqString).matches;
  }

  videoProporzione() {
    // Figure out and save aspect ratio for each video
    this.video.data('aspectRatio', this.video.height / this.video.width).removeAttr('height').removeAttr('width');

    // When the window is resized
    // (You'll probably want to debounce this)
    this.finestraW = 0;
  }

  scalaVideo() {
    this.finestraW = jQuery(window).width();
    // $('.pippoo').append(finestraW+" ");
    let newWidth = this.fluidEl.width();
    if (this.finestraW <= 992) {
      newWidth = this.fluidEl.width();
    }
    // Resize all videos according to their own aspect ratio
    this.video.width(newWidth)
      .height(newWidth * this.video.data('aspectRatio'));
  }
}();
